import {ref} from 'vue'
import {onClickOutside} from '@vueuse/core'

/**
 * Composable to create visibility toggles
 */
export function useVisibilityToggle(clickOutsideRef, ignore) {

  //Create refs
  const isVisible = ref(false)
  const afterHideHook = ref(null)
  const afterShowHook = ref(null)
  const beforeHideHook = ref(null)
  const beforeShowHook = ref(null)

  //Hooks
  const onHide = fn => afterHideHook.value = fn
  const onShow = fn => afterShowHook.value = fn
  const beforeHide = fn => beforeHideHook.value = fn
  const beforeShow = fn => beforeShowHook.value = fn

  //Helper to call a hook
  const callHook = hook => {
    if (hook.value) {
      return hook.value()
    }
  }

  //Hide handler
  const hide = () => {
    if (callHook(beforeHideHook) === false) {
      return
    }
    isVisible.value = false
    callHook(afterHideHook)
  }

  //Show handler
  const show = () => {
    if (callHook(beforeShowHook) === false) {
      return
    }
    isVisible.value = true
    callHook(afterShowHook)
  }

  //Toggle
  const toggle = (event) => {
    if (event) {
      event.isHandled = true
    }
    if (isVisible.value) {
      hide()
    }
    else {
      show()
    }
  }

  //Click outside handling if refs passed
  if (clickOutsideRef) {

    //Ensure ignore array
    if (!Array.isArray(ignore)) {
      ignore = ignore ? [ignore] : []
    }

    //Always ignore these global classes as we don't want dropdowns to close
    //when these elements are interacted with
    ignore.push('.vs__dropdown-menu')

    //Apply handler
    onClickOutside(clickOutsideRef, hide, {ignore})
  }

  //Expose interface
  return {

    //Refs
    isVisible,

    //Functions
    show,
    hide,
    toggle,
    onShow,
    onHide,
    beforeHide,
    beforeShow,
  }
}
